import { Store } from 'redux/root';
import { MessagePayload } from './types';

export const selectorGetPushMessage = (store: Store): MessagePayload => {
	return store.pushesRedux.notification;
};
